module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_c('span', {
    staticClass: "subtitle"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("用户名")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.username))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('el-input', {
    staticClass: "shenspan",
    attrs: {
      "type": "text",
      "placeholder": "请填写姓名"
    },
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("联络电话")]), _vm._v(" "), _c('el-input', {
    staticClass: "shenspan",
    attrs: {
      "disabled": "",
      "placeholder": "请填写联络电话",
      "type": "text"
    },
    model: {
      value: (_vm.user.phone),
      callback: function($$v) {
        _vm.$set(_vm.user, "phone", $$v)
      },
      expression: "user.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("地址")]), _vm._v(" "), _c('el-input', {
    staticClass: "shenspan",
    attrs: {
      "disabled": "",
      "placeholder": "请填写联络地址",
      "type": "text"
    },
    model: {
      value: (_vm.user.addr),
      callback: function($$v) {
        _vm.$set(_vm.user, "addr", $$v)
      },
      expression: "user.addr"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('el-input', {
    staticClass: "shenspan",
    attrs: {
      "disabled": "",
      "placeholder": "请填写邮箱",
      "type": "text"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("专业")]), _vm._v(" "), _c('el-input', {
    staticClass: "shenspan",
    attrs: {
      "placeholder": "请填写专业",
      "type": "text"
    },
    model: {
      value: (_vm.user.major),
      callback: function($$v) {
        _vm.$set(_vm.user, "major", $$v)
      },
      expression: "user.major"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("指导老师")]), _vm._v(" "), _c('el-input', {
    staticClass: "shenspan",
    attrs: {
      "placeholder": "请填写指导老师",
      "type": "text"
    },
    model: {
      value: (_vm.user.teacher),
      callback: function($$v) {
        _vm.$set(_vm.user, "teacher", $$v)
      },
      expression: "user.teacher"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("编号")]), _vm._v(" "), _c('el-input', {
    staticClass: "shenspan",
    attrs: {
      "placeholder": "请填写你的编号",
      "type": "text"
    },
    model: {
      value: (_vm.user.userid),
      callback: function($$v) {
        _vm.$set(_vm.user, "userid", $$v)
      },
      expression: "user.userid"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("学校")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.school))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("学校所在省份")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.province))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("个人生活照")]), _vm._v(" "), _c('el-upload', {
    staticClass: "avatar-up shenspan",
    class: {
      avatarDisabled: _vm.avatarIsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 1,
      "accept": "image/jpeg,image/png,image/jpg",
      "file-list": _vm.avatarList,
      "on-success": _vm.handleSuccess,
      "on-error": _vm.handleError,
      "on-change": _vm.handleChange,
      "on-remove": _vm.handleRemove,
      "on-preview": _vm.handlePreview,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传个人生活照一张")]), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG/PNG格式，大小不超过2M"), _c('br'), _vm._v("不建议为证件照或者艺术照")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogUrl,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "saveInfo"
  }, [_c('span', {
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    },
    on: {
      "click": _vm.prepage
    }
  }, [_vm._v("返 回")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("修改基本资料")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-291ee260"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ChangeInfo.vue
// module id = 613
// module chunks = 1